import { OktaAuth } from "@okta/okta-auth-js";
import { RouteConstants } from "./constants/RouteConstants";

export const OKTA_CALLBACK_PATH = RouteConstants.LOGIN_CALLBACK;
export const OKTA_SCOPES = ["openid", "profile", "email", "status-api"];

export const oktaAuth = new OktaAuth({
  issuer: process.env.REACT_APP_OKTA_ISSUER,
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
  redirectUri: `${window.location.origin}${OKTA_CALLBACK_PATH}`,
  pkce: true,
  responseType: "code",
  scopes: OKTA_SCOPES,
  tokenManager: {
    storageKey: `status-okta-token-storage-${process.env.REACT_APP_OKTA_CLIENT_ID}`,
  },
});
